<template>
  <div class="sub-player-data">
    <div class="score-list">
      <div class="score-item" v-for="(item, index) in playersList" :key="index">
        <div class="score-name">{{ item.name }}</div>
        <div
          class="score-rank "
          v-for="(i, j) in item.rankList"
          :key="j"
          :class="j == 0 && index % 2 == 0 ? 'one-red' : ''"
        >
          <div class="rank">{{ j + 1 }}</div>
          <div>
            <div class="player-name">{{ i.playerName }}</div>
            <div class="player-team">{{ i.playerTeam }}</div>
          </div>
          <div class="score">{{ i.score }}</div>
        </div>
      </div>
    </div>
    <div class="team-list">
      <div class="team-box">
        <div
          v-for="(item, index) in tabList"
          :key="index"
          class="team-item"
          :class="index == tabIndex ? 'team-active' : ''"
          @click="handleTab(item, index)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="row row-title">
      <div class="col-1">排名</div>
      <div class="col-2">球员</div>
      <div class="col-3">号码</div>
      <div class="col-4">分钟</div>
      <div class="col-5">得分</div>
      <div class="col-6">投篮</div>
      <div class="col-7">2分</div>
      <div class="col-8">3分</div>
      <div class="col-9">罚球</div>
      <div class="col-10">前板</div>
      <div class="col-11">后板</div>
      <div class="col-12">篮板</div>
      <div class="col-13">助攻</div>
      <div class="col-14">失误</div>
      <div class="col-15">抢断</div>
      <div class="col-16">扣篮</div>
    </div>
    <div class="row">
      <div class="col-1">1</div>
      <div class="col-2">球员姓名</div>
      <div class="col-3">号码</div>
      <div class="col-4">分钟</div>
      <div class="col-5">得分</div>
      <div class="col-6">投篮</div>
      <div class="col-7">2分</div>
      <div class="col-8">3分</div>
      <div class="col-9">罚球</div>
      <div class="col-10">前板</div>
      <div class="col-11">后板</div>
      <div class="col-12">篮板</div>
      <div class="col-13">助攻</div>
      <div class="col-14">失误</div>
      <div class="col-15">抢断</div>
      <div class="col-16">扣篮</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasketballPlayerData',
  props: {},
  data() {
    return {
      tabList: [{ name: '代表队名字' }, { name: '代表队名字' }],
      tabIndex: 0,
      playersList: [
        {
          name: '得分',
          rankList: [
            {
              playerName: '球员姓名',
              playerTeam: '球员队伍',
              score: 31.8,
            },
            {
              playerName: '球员姓名',
              playerTeam: '球员队伍',
              score: 32,
            },
          ],
        },
        {
          name: '篮板',
          rankList: [
            {
              playerName: '球员姓名',
              playerTeam: '球员队伍',
              score: 31.8,
            },
            {
              playerName: '球员姓名',
              playerTeam: '球员队伍',
              score: 32,
            },
          ],
        },
        {
          name: '助攻',
          rankList: [
            {
              playerName: '球员姓名',
              playerTeam: '球员队伍',
              score: 31.8,
            },
            {
              playerName: '球员姓名',
              playerTeam: '球员队伍',
              score: 32,
            },
          ],
        },
        {
          name: '抢断',
          rankList: [
            {
              playerName: '球员姓名',
              playerTeam: '球员队伍',
              score: 31.8,
            },
            {
              playerName: '球员姓名',
              playerTeam: '球员队伍',
              score: 32,
            },
          ],
        },
        {
          name: '盖帽',
          rankList: [
            {
              playerName: '球员姓名',
              playerTeam: '球员队伍',
              score: 31.8,
            },
            {
              playerName: '球员姓名',
              playerTeam: '球员队伍',
              score: 32,
            },
          ],
        },
        {
          name: '三分命中率',
          rankList: [
            {
              playerName: '球员姓名',
              playerTeam: '球员队伍',
              score: 31.8,
            },
            {
              playerName: '球员姓名',
              playerTeam: '球员队伍',
              score: 32,
            },
          ],
        },
      ],
    }
  },
  components: {},
  mounted() {},
  methods: {
    handleTab(item, index) {
      this.tabIndex = index
    },
  },
  watch: {},
}
</script>

<style scoped lang="scss">
.sub-player-data {
  width: 1200px;
  margin: 0 auto;
  padding-top: 30px;
  padding-bottom: 30px;
  .score-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-content: flex-start;
    .score-item {
      width: 380px;
      height: 170px;
      margin-bottom: 30px;

      .score-name {
        background-color: #323232;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        height: 50px;
        line-height: 50px;
        padding-left: 30px;
      }
      .score-rank {
        display: flex;
        justify-content: space-between;
        padding-left: 30px;
        align-items: center;
        font-weight: bold;
        height: 60px;
        align-items: center;
        .rank {
          font-weight: bold;
          width: 30px;
          text-align: center;
          margin-right: 20px;
        }
        .player-name {
          width: 220px;
          text-align: left;
        }
        .player-team {
          width: 220px;
          text-align: left;
        }
        .score {
          width: 80px;
          font-size: 20px;
          text-align: center;
        }
      }
      .one-red {
        background: linear-gradient(90deg, #ff7815, #ffffff 80%);
      }
      .one-blue {
        background: linear-gradient(90deg, #0073d5, #ffffff 80%);
        // background: linear-gradient(90.00deg, rgba(0,115,213,1.00) 0%,rgba(255,255,255,0.00) 0%);
      }
    }
  }
  .team-list {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
    .team-box {
      width: 400px;
      background-color: #c4c4c4;
      line-height: 50px;
      height: 50px;
      display: flex;
      justify-content: center;
      border-radius: 8px;
      padding: 2px;
      .team-item {
        width: 198px;
        height: 46px;
        border-radius: 8px;
        cursor: pointer;
        text-align: center;
        font-weight: bold;
        font-size: 18px;
        line-height: 46px;
      }
      .team-active {
        background-color: #fff;
      }
    }
  }
  .row {
    display: flex;
    justify-content: flex-start;
    line-height: 60px;
    height: 60px;
    text-align: center;
    padding: 0 30px;
    .col-1 {
      width: 10%;
      text-align: left;
    }
    .col-2 {
      width: 20%;
      text-align: left;
    }
    .col-3 {
      width: 5%;
    }
    .col-4 {
      width: 5%;
    }
    .col-5 {
      width: 5%;
    }

    .col-6 {
      width: 5%;
    }
    .col-7 {
      width: 5%;
    }
    .col-8 {
      width: 5%;
    }
    .col-9 {
      width: 5%;
    }
    .col-10 {
      width: 5%;
    }
    .col-11 {
      width: 5%;
    }
    .col-12 {
      width: 5%;
    }
    .col-13 {
      width: 5%;
    }
    .col-14 {
      width: 5%;
    }
    .col-15 {
      width: 5%;
    }
    .col-16 {
      width: 5%;
    }
  }

  .row-title {
    font-weight: bold;
    background-color: #323232;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/match/basketball/components/BasketballPlayerData.vue